import React, { useContext, useEffect, useState } from 'react';
import PaymentSettingsLink from '../components/paymentSettings/PaymentSettingsLink';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import AppContext from '../Context/AppContext';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import SideLeft from '../layout/SideLeft';
import StatProjects from '../components/StatProjects';
import WidGetDateSelect from '../componentsWidgets/WidGetDateSelect';
import TabPaiementItem from '../libraries/TabPaiementItem';
import WidgetPaiementStat from '../componentsWidgets/WidgetPaiementStat';
import WidgetSendNotif from '../componentsWidgets/WidgetSendNotif';

const PaiementSport = () => {
    const { socketSport, setNotifAskPaiement } = useSocket();
    const { setCurrentPage } = useContext(AppContext)
    const user = infoUser();
    const [result, setResult] = useState(null)
    const [date, setDate] = useState(new Date())
    const [selectStatus, setSelectStatus] = useState('tous')

    const init = (d) => {
        setCurrentPage('paiement_sport')
        setNotifAskPaiement(null)
        if (socketSport) {
            socketSport.on('notif_new_paiement', (e) => {
                //init()
            })
            socketSport.on('notif_confirm_paiement', (e) => {
                //init()
            })
            socketSport && socketSport.emit('empire_tracker_list_ask_paiement', { token: user.expecttoken, date: d || date }, (e) => {
                setSelectStatus('tous')
                setResult(e)
                console.log(e);
            })
        }
    }
    const itemSelectedStatus = () => {
        if (selectStatus) {
            const findBySelect = result.find(e => e.status == selectStatus);
            if (findBySelect) {
                return findBySelect.data;
            }
        }
        return []
    }

    useEffect(() => {
        init()
    }, [socketSport])
    return (
        <MainLayout>
            <CenterLayout>
                <WidGetDateSelect date={date} setDate={(d) => {
                    setDate(d)
                    init(d)
                }} />
                {result?.length > 0 && (
                    <>
                        <nav className='df gap1 aic'>
                            {result.map((s, i) => (
                                <button onClick={() => {
                                    setSelectStatus(s.status)
                                }} key={i + "btn-status-date"} className={`card carder cw ttc ${selectStatus == s.status ? "active" : ""}`}>{s.status}</button>
                            ))}
                        </nav>
                        {/** LIST */}
                        {itemSelectedStatus()?.length > 0 && itemSelectedStatus().map((s, i) => (
                            <TabPaiementItem key={i + "__item_paiement_list"} s={s} init={init} type="sport" />
                        ))}
                    </>
                )}
            </CenterLayout>
            <SideLeft>

                <StatProjects open={(cmp) => { }} />
                {socketSport && (
                    <>
                        <p className='fm cw mb1 fs20'>Abonnements</p>
                        <div className="df fdc gap1">
                            <WidgetPaiementStat status={"done"} label="Paiement validé" />
                            <WidgetPaiementStat status={"paid"} label="Paiement à venir" />
                        </div>
                        <p className='fm cw mb1 fs20 '>Paramettre</p>
                        <PaymentSettingsLink />
                        <p className='fm cw mb1 fs20'>Notif</p>
                        <WidgetSendNotif sign='N' label={"Envoyer une notif"} />
                    </>
                )}
            </SideLeft>
        </MainLayout>
    );
};

export default PaiementSport;